<template>
  <!-- View notifications modal -->
  <v-dialog v-model="notificationsDialog" persistent max-width="800">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          v-if="isUser"
          :content="notifications_count"
          :value="notifications_count"
          color="#85a43c"
          overlap
          left
        >
          <v-icon >mdi-email-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="qmkey-notifications-table mx-auto">
      <v-card-title>
        <span class="modal-title">User Notifications</span>
        <v-spacer style="max-width: 100px"></v-spacer>
        <v-text-field
          v-model="search"
          ref="notificationsSearchableText"
          prepend-inner-icon="mdi-magnify"
          label="Search ......"
          single-line
          hide-details
          style="float:right"
          class="notifications-searchable-text"
          :class="{ 'closed' : searchClosed}"
          solo
          flat
          clearable    
          dense
          filled
          background-color="white"
          @click:prepend-inner="toogleSearch($event)"
          @blur="toogleSearch($event)"
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="black"
          text @click="notificationsDialog = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="notifications"
          item-key="uid"
          show-select
          :sort-by="'date'"
          :sort-desc="true"
          show-expand
          class="qmkey-notifications"
          :search="search"
          dense
          :item-class="notificationsRowClass"
          @click:row="goToExplorerItem"
          must-sort
          :header-props="{'sort-icon': sort_icon}"
          >
          <template v-slot:[`item.date`]="{ item }">
              {{
                new Date(
                item.date).toLocaleDateString(
                  options={'dateStyle':'short'})
              }}
          </template>
          <template v-slot:item.current_workflow_state_str="{ item }">
            <span
              v-bind:class="getStateColor(item.is_closed)"
            >
              {{ item.current_workflow_state_str }}
            </span>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td :colspan="headers.length +2">
              <div>
                <b-button
                  v-html="item.message"
                  @click="goToExplorerItem(item)"
                  variant="link"
                  class="notification-text"
                >
                </b-button>
              </div>
            </td>
          </template>          
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#85a43c"
          text
          @click="readNotifications()"
          v-bind:disabled="selected.length < 1"
          small
          class="qmkey-notifications-table-btn"
        >
          Marcar seleccionadas como leídas
        </v-btn>
        <v-btn
          color="secondary"
          text @click="notificationsDialog = false"
          small
          class="qmkey-notifications-table-btn"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>  
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'

export default {
  name: 'NotificationsDialog',
  data() {
    return {
      error_message: '',
      jsData: '',
      headers: [
        {
          text: 'Asunto',
          align: 'start',
          sortable: true,
          value: 'subject',
        },
        {
          text: 'Autor',
          sortable: true,
          value: 'author',
        },
        {
          text: 'Fecha',
          sortable: true,
          value: 'date',
        },
        {
          text: 'Estado',
          sortable: true,
          value: 'current_workflow_state_str',
        },
      ],
      search: '',
      loading: false,
      message:'',
      selected:[],
      expanded: [],
      notificationsDialog: false,
      searchClosed: true,
    }
  },
  computed: {
    ...mapGetters(['isUser', 'isManager', 'isAdmin']),
    ...mapState(['menus', 'sitePath', 'allSites', 'user',
                 'processID', 'filteredProcesses',
                 'current_business_process',
                 'searchText', 'filtersFormData', 'notifications', 'notifications_count']),
    sort_icon() {
      return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending'
    },
  },
  mounted: function() {
    // this.REFRESH_STATE(this)
    this.loadUserNotifications();

    setInterval(function () {
      this.loadUserNotifications();
    }.bind(this), 300000); 
  },
  updated: function() {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }
  },
  methods: {
    goToExplorerItem(notification){
      // TODO: reset QUnit filters
      // TODO: execute reaad notification on click
      this.selected.push(notification)
      this.readNotifications()
      let bp_reference = encodeURIComponent(notification.parent_business_process)
      let pk = encodeURIComponent(notification.parent_process)
      // FIXME: no harcode current_business_process
      // DOCUMENTS page need reload explorer to hide documents
      if (this.$route.name  === 'explorer' && this.current_business_process != 'DOCISODEFAULT'){
        this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: bp_reference,
            process_id: '',
            search_text: '',
            filters_form: '',
            units_page: 1,
            pk: notification.parent_process
        })
      }
      else {
        let url = '/explorer?business_process=' + bp_reference + '&pk=' + pk
        this.$router.push(url)
      }
      // Close Notifications modal
      this.notificationsDialog = false
    },
    loadUserNotifications() {
        if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
            QUnit.getUserNotifications(
                this.sitePath,
                'NOTIF_DEFAULT',
                this.$session.get('user').id
            )
            .then(data => {
                this.SET_CURRENT_USER_NOTIFICATIONS(data)
            })
            
        }
    },
    deleteNotifications(){
      //TODO
      // Close Notifications modal
      this.notificationsDialog = false
    },
    readNotifications(){
        var uids = []
        for (var i=0; i<this.selected.length;i++){
            if (!this.selected[i].is_closed){ 
                uids.push(this.selected[i].uid)
            }
        }
        if (uids.length >0) {
            QUnit.executeReadNotifications(
            this.sitePath,
            uids
            )
            .then(data => {
                this.SET_CURRENT_USER_NOTIFICATIONS(data)
            })
         }
    },
    getStateColor(is_closed) {
      if (is_closed) {
        return 'final_state'
      }
      return 'working_state'
    },
    ...mapActions(['GET_SITES', 'REFRESH_STATE', 'EXPLORE_UNITS']),
    ...mapMutations([
      'SET_SEARCH_TEXT',
      'SET_CURRENT_USER_NOTIFICATIONS',
    ]),
    
    notificationsRowClass(item){
      return 'notifications-table-row'
    },
    toogleSearch: function(evt) {
      if (this.searchClosed){
        this.$refs.notificationsSearchableText.focus()
      }
      if (!this.search_text) {
        this.searchClosed = !this.searchClosed
      }
    },
    customSort: function(items, index, isDesc) {
      // FIXME:TODO: Deprecated not in use
      items.sort((a, b) => {
      if (index[0]=='date') {
        // FIXME: No harcoded
        let parts_a = a[index].split('/')
        let parts_b = b[index].split('/')
        //JavaScript counts months from 0:
        let date_a = new Date(parts_a[2], parts_a[1] - 1, parts_a[0])
        let date_b = new Date(parts_b[2], parts_b[1] - 1, parts_b[0])
        if (!isDesc[0]) {
            return date_b - date_a
        } else {
            return date_a - date_b
        }
      }
      else {
        if(typeof a[index] !== 'undefined'){
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          }
          else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
      });
      return items;
    }
  
  },
}
</script>


<style lang="scss">
  @import "@/sass/header.scss";
</style>
